import { CellRenderers } from '@cmg/data-grid';
import type { DotStatusProps } from '@cmg/design-system';

import { OfferingStatus } from '../../../../../../graphql/__generated__';
import type {
  CalendarGridColDef,
  CalendarGridContext,
  CalendarGridRowData,
  CalendarGridSetFilterParams,
  CalendarGridSetFilterValuesFunc,
} from '../../CalendarGrid.model';

export type Value = CalendarGridRowData['statusDisplayName'];

export const getStatusColor = (
  _value: string,
  data: CalendarGridRowData | undefined
): DotStatusProps['color'] => {
  const { status } = data?.attributes ?? {};

  switch (status) {
    case OfferingStatus.Filed:
      return 'primary';
    case OfferingStatus.Live:
      return 'success';
    case OfferingStatus.Priced:
      return 'secondary';
    case OfferingStatus.Postponed:
      return 'warning';
    case OfferingStatus.Withdrawn:
    case OfferingStatus.Terminated:
      return 'error';
    default:
      return 'disabled';
  }
};

export const setFilterValuesFunc: CalendarGridSetFilterValuesFunc = ({ success, context }) => {
  success((context as CalendarGridContext).offeringStatuses.map(status => status.label));
};

const offeringStatusColDef: CalendarGridColDef<Value> = {
  field: 'statusDisplayName',
  width: 141,
  headerName: 'Offering Status',
  type: 'text',
  filter: 'agSetColumnFilter',
  filterParams: {
    values: setFilterValuesFunc,
  } satisfies CalendarGridSetFilterParams,
  cellRenderer: CellRenderers.DotStatusCellRenderer,
  cellRendererParams: {
    getStatusColor,
  },
};

export default offeringStatusColDef;
